import { Box, Button, ButtonGroup, Select, Text, VStack } from "@chakra-ui/react";
import React from "react";

const ExportSettings = ({exportIn, setExportIn, saveToLibrary, setSaveToLibrary}) => {
    return (
        <VStack
            width={"100%"}
            height={"100%"}
            spacing={0}
            alignItems={"flex-start"}
        >
            <Text fontSize={"16px"} fontWeight={600} color={"#333333"} lineHeight={"24px"}>
                Export In
            </Text>
            <Select
                size="lg"
                width={"100%"}
                height={"48px"}
                marginTop={"16px"}
                onChange={(e) => setExportIn(e.target.value)}
                fontSize={"14px"}
                color={exportIn ? "#1D1D1D" : "#6B7C93"}
                _focusVisible={{ color: "#1D1D1D"}}
            >
                <option value="source">Source Template</option>
                {/* <option value="company">Company Template</option> */}
            </Select>
            <Text
                marginTop={"24px"}
                lineHeight={"24px"}
                fontSize={"14px"}
                fontWeight={600}
                color={"#333333"}
            >
                Save to library
            </Text>
            <Select
                size="lg"
                width={"100%"}
                height={"48px"}
                marginTop={"16px"}
                onChange={(e) => setSaveToLibrary(e.target.value)}
                fontSize={"14px"}
                color={saveToLibrary ? "#1D1D1D" : "#6B7C93"}
                _focusVisible={{ color: "#1D1D1D"}}
            >
                <option value="yes">Yes</option>
                <option value="no">No</option>
            </Select>
        </VStack>
    )
}

// const ExportSettings = ({ exportIn, setExportIn, saveToLibrary, setSaveToLibrary, startAnnotation, htmlChunks }) => {
//     const [chunkStates, setChunkStates] = React.useState(htmlChunks);
//     const chunkRefs = React.useRef([]);
//     const [annotations, setAnnotations] = React.useState([]);
  
//     const handleHighlight = (chunkIdx, highlightType) => {
//       const selection = window.getSelection();
//       if (!selection || selection.isCollapsed) return;
  
//       const range = selection.getRangeAt(0);
//       const container = chunkRefs.current[chunkIdx];
//       if (!container.contains(range.commonAncestorContainer)) return;
  
//       const selectedText = selection.toString();
//       const mark = document.createElement("mark");
//       mark.setAttribute("data-type", highlightType);
//       mark.setAttribute("data-id", `${chunkIdx}-${Date.now()}`);
//       mark.style.backgroundColor = highlightType === "question" ? "#ffe066" : "#c3f7c8";
//       range.surroundContents(mark);
  
//       const updatedHTML = container.innerHTML;
//       const updatedChunks = [...chunkStates];
//       updatedChunks[chunkIdx] = updatedHTML;
//       setChunkStates(updatedChunks);
  
//       // Compute offset
//       const plainText = container.textContent || "";
//       const offset = plainText.indexOf(selectedText); // simple first match
//       const endOffset = offset + selectedText.length;
  
//       const newAnnotation = {
//         chunkIndex: chunkIdx,
//         text: selectedText,
//         type: highlightType,
//         startOffset: offset,
//         endOffset: endOffset,
//       };
//       console.log("[ExportSettings] New annotation is", newAnnotation)
  
//       const updatedAnnotations = [...annotations, newAnnotation];
//       setAnnotations(updatedAnnotations);
//     //   onAnnotationsChange && onAnnotationsChange(updatedAnnotations);
  
//       selection.removeAllRanges();
//     };

//     return (
//         <VStack
//             width={"100%"}
//             maxW={"100%"}
//             height={"100%"}
//             spacing={0}
//             alignItems={"flex-start"}
//             paddingLeft={htmlChunks.length > 0 ? "0" : "20%"}
//             paddingRight={htmlChunks.length > 0 ? "0" : "20%"}
//         >
//             {
//                 htmlChunks.length > 0 ? htmlChunks.map((chunk, idx) => (
//                     <Box key={idx}>
//                         <ButtonGroup variant="outline" size="sm" mb={4}>
//                             <Button
//                                 colorScheme={"yellow"}
//                                 onClick={() => handleHighlight(idx, "question")}
//                             >
//                                 Mark as Question
//                             </Button>
//                             <Button
//                                 colorScheme={"green"}
//                                 onClick={() => handleHighlight(idx, "answer")}
//                             >
//                                 Mark as Answer
//                             </Button>
//                         </ButtonGroup>
//                         <Box
//                             ref={(el) => (chunkRefs.current[idx] = el)}
//                             w="100%"
//                             maxW="100%"
//                             border="1px solid #ddd"
//                             borderRadius="md"
//                             boxShadow="sm"
//                             bg="white"
//                             p={4}
//                             dangerouslySetInnerHTML={{ __html: chunk }}
//                         />
//                     </Box>
//                 )): (
//                     <Box
//                         fontSize={"16px"}
//                         width={"100%"}
//                         maxW={"100%"}
//                         display={"flex"}
//                         justifyContent={"center"}
//                         alignItems={"center"}
//                         borderRadius={"8px"}
//                         border={"1px solid #2584FD"}
//                         _hover={{
//                             backgroundColor: "#E4F0FF",
//                             cursor: "pointer",
//                         }}
//                         onClick={() => {
//                             startAnnotation();
//                         }}
//                     >
//                         Click to start shedding
//                     </Box>
//                 )
//             }
//         </VStack>
//     )
// }

export default ExportSettings;